import React from 'react';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';
import HouseMissingImage from '../img/single-family.svg';

import './FourThreeImage.scss';


function FourThreeImage(props: {
	src: string;
	alt: string;
	onClick?: () => void;
	className?: string;
	hoverEffects?: boolean;
}) {
	const [loadingTakingTooLong, setLoadingTakingTooLong] = React.useState(false);

	React.useEffect(() => {
		// If image takes longer than 5 seconds to load, change state (shows HouseMissingImage)
		const timer = setTimeout(() => {
			setLoadingTakingTooLong(true);
		}, 5000);
		return () => clearTimeout(timer);
	}, []);

	return (
		<div className={classNames('fourThreeImage__wrapper', props.hoverEffects ? 'fourThreeImage__wrapper--effects' : '')}
		>
			{props.src
				? (
					<img
						src={props.src}
						alt={props.alt}
						onClick={props.onClick}
						className={props.className}
					/>
				) : loadingTakingTooLong ? (
					<img
						src={HouseMissingImage}
						alt="Default home placeholder"
						onClick={props.onClick}
						className={props.className}
					/>
				) : (
					<Skeleton height={420} style={{ width: '100%', lineHeight: 2, borderRadius: 0 }} />
				)}
		</div>
	);
}

export default FourThreeImage;
